import {Injectable, signal} from '@angular/core';

@Injectable()
export class FunctionSelectionDialogStateService {
  dialogVisible = signal(false);
  currentEntityId = signal<number | null>(null);
  currentEntityName = signal<string>('');

  openDialog(entityId: number, entityName: string) {
    this.currentEntityId.set(entityId);
    this.currentEntityName.set(entityName);
    this.dialogVisible.set(true);
  }

  closeDialog() {
    this.dialogVisible.set(false);
  }
}
